import { render, staticRenderFns } from "./Uzytkownik.vue?vue&type=template&id=4323a866&scoped=true&"
import script from "./Uzytkownik.vue?vue&type=script&lang=js&"
export * from "./Uzytkownik.vue?vue&type=script&lang=js&"
import style0 from "./Uzytkownik.vue?vue&type=style&index=0&id=4323a866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323a866",
  null
  
)

export default component.exports